import type { ComponentProps } from 'react';

import styles from './hamburger-menu-button.module.scss';

type Props = ComponentProps<'button'>;

export const HamburgerMenuButton = (props: Props) => {
  const { className, children, ...rest } = props;
  return (
    <button
      className={[className, styles.hamburgerMenuButton]
        .filter(Boolean)
        .join(' ')}
      type="button"
      {...rest}
    >
      {children}
    </button>
  );
};
